export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/AiNumberReader.worker.7b1b5996.worker.js");
}
